import React from 'react';
import { ContentContainer } from '../../_sections/Content/ContentContainer';
import { StandardLayout } from '../Standard/StandardLayout';
import { SectionWithWidgets } from '../../types/api/Sections';
import { MaybeEmpty, isEmptyBlock } from '../../types/api/Block';
import { ContextSection } from '../../_sections/Context/ContextSection';
import { isNullOrUndefined } from '../../lib/typeGuards';
import { ContextBlock } from '../../_blocks/mapContextBlock';

/**
 * Since in the backend the blocks come from different services, it is very
 * complicated to check the content from blocks and determine the correct layout.
 * For this reason, we determine in the frontend with an exception which layout type is correct.
 * */
const isEveryBlockEmpty = (contextSection?: ContextSection): boolean | undefined => {
  if (isNullOrUndefined(contextSection)) return true;
  return contextSection.widgets.flatMap<MaybeEmpty<ContextBlock>>(widget => widget.blocks).every(isEmptyBlock);
};

type StandardDynamicWidthProps = {
  contentSection: SectionWithWidgets;
  contextSection?: ContextSection;
};

/**
 * Renders the StandardDynamicWidthLayout Layout, which can contain Content and Context section
 * If context section is empty, then content section takes full width
 */
export function StandardDynamicWidthLayout({ contentSection, contextSection }: StandardDynamicWidthProps) {
  const everyBlockEmpty = isEveryBlockEmpty(contextSection);

  if (!everyBlockEmpty) {
    return <StandardLayout contentSection={contentSection} contextSection={contextSection} />;
  }

  return <ContentContainer className="content-full" section={contentSection} />;
}
